import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";

import history from "components/common/navigation/AppHistory";

import LangSelector from "components/utils/LangSelector";
import { PROJECTS_ROUTE } from "../routes/routes";

import "css/admin/signup.scss";

export class SignupStep4UI extends Component {
  constructor(props) {
    super(props);
  }

  onClick = () => {
    history.push(`${PROJECTS_ROUTE}/new`);
  };

  render() {
    const { t } = this.props;

    return (
      <div className="signup-step-container signup-step-takeoff-container">
        <div className="signup-step-table-container">
          <div className="signup-step-table-item">
            <i className="material-icons">local_play</i>
            {t("create_project")}
          </div>
          <div className="signup-step-table-item">
            <i className="material-icons">add_box</i>
            {t("add_contents")}
          </div>
          <div className="signup-step-table-item">
            <i className="material-icons">shopping_basket</i>
            {t("create_offer")}
          </div>
          <div className="signup-step-table-item">
            <i className="material-icons">web</i>
            {t("personalize_ux")}
          </div>
        </div>
        <div className="signup-btn-container">
          <div className="signup-btn-wrapper">
            <div className="signup-btn-confirm" onClick={this.onClick}>
              <span>{t("btn_confirm_step4")}</span>
            </div>
            <LangSelector languages={["en", "fr"]} />
          </div>
        </div>
      </div>
    );
  }
}

SignupStep4UI.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation("editor-signup")(SignupStep4UI);
